export class ValidationService {
  static requiredValidator() {
    return {
      value: true,
      message: "This field is required.",
    };
  }
  static emailValidator() {
    return {
      value: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
      message: "Please enter a valid email address.",
    };
  }
  static positiveNumber(value: any) {
    if (value < 1) {
      return "Please enter any positive number";
    } else {
      return;
    }
  }
  static dateTimeValidatorMoreThanCurrentTime(value: any) {
    console.log(value, "valuevaluevaluevaluevaluevalue");
    if (value) {
      return "The passwords do not match";
    } else {
      return "The passwords do not match";
    }
  }
  static passwordValidator() {
    return {
      value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
      message:
        "Password must contain at least 8 characters, one lowercase letter, one uppercase letter, one numeric digit, and one special character",
    };
  }
  static domainValidator() {
    return {
      //eslint-disable-next-line
      value: /^(?!(https:\/\/|http:\/\/|mailto:|smtp:|ftp:\/\/|ftps:\/\/))(((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,86}[a-zA-Z0-9]))\.(([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,73}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25})))|((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,162}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25}))))$/,
      message: "must be a valid hostname",
    };
  }
  static urlValidator() {
    return {
      value: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/,
      message: "must be a valid link",
    };
  }
}
